<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">

        <div class="card mb-4">
          <div class="card-header pb-0">
            <h4>Allenamenti</h4>
            <button type="button" id="add-btn" class="btn btn-primary" @click="openHorseTrainingForm">+ Nuovo</button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">

            <div>
              <ul
              class="p-1 bg-transparent nav nav-pills nav-fill"
              role="tablist"
              style="max-width: 400px; margin: auto;"
            >
              <li class="nav-item">
                <a
                  class="px-0 py-1 mb-0 nav-link active"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  role="tab"
                  aria-selected="true"
                  :class="{ active: activeTab === 'inprogress' }"
                  @click="setActiveTab('inprogress')"
                >
                  <span class="ms-1">In Corso</span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="px-0 py-1 mb-0 nav-link"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  role="tab"
                  aria-selected="false"
                  :class="{ active: activeTab === 'future' }"
                  @click="setActiveTab('future')"
                >
                  <span class="ms-1">Futuro</span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="px-0 py-1 mb-0 nav-link"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  @click="setActiveTab('executed')"
                  :class="{ active: activeTab === 'executed' }"
                  role="tab"
                  aria-selected="false"
                >
                  <span class="ms-1">Eseguito</span>
                </a>
              </li>
            </ul>
            </div>
            <div class="table-responsive p-3">
              <custom-table ref="table$" :rows="data" @action="runAction" :columns="[
              {
                  title: 'Training',
                  type: 'text',
                  data: 'training.name',
              },
              {
                  title: 'Exercise',
                  type: 'text',
                  data: 'exercise.name',
              },
              {
                  title: 'Repetitions',
                  type: 'text',
                  data: 'repetitions',
              },
              {
                  title: 'From',
                  type: 'date',
                  data: 'from_date',
              },
              {
                  title: 'To',
                  type: 'date',
                  data: 'to_date',
              },
              {
                  title: 'Note',
                  type: 'text',
                  data: 'note',
              },
              {
                  title: 'Free Field',
                  type: 'text',
                  data: 'free_field',
              },
              {
                  title: 'Ranking',
                  type: 'text',
                  data: 'ranking',
              },
              ]" :actions="[
                  {
                      title: 'Modifica',
                      tooltip: 'edit',
                      key: 'edit',
                  },
              ]" 
                :pagination="pagination"
                @page-changed="handlePageChange"
                @update-pagination="handlePaginationUpdate"
                @search-changed="handleSearchChange"
              />

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  
  <modal v-model="horseTrainingForm" title="Allenamento">

    <div>
      <Vueform ref="form$" v-model="horse_training" sync>
            <HiddenElement name="id" />

            <div class="row">
              <div class="col-10">
                <SelectElement
                    name="training_id"
                    :native="false"
                    label="Allentamento"
                    rules="required"
                    :items="trainings"
                />
              </div>
              <div class="col-2 text-right">
                <button type="button" class="btn btn-success add-btn mt-4" @click="trainingForm=1">+</button>
              </div>
            </div>

            <div class="row">
              <div class="col-10">
                <SelectElement
                    name="exercise_id"
                    :native="false"
                    label="Esercizio"
                    rules="required"
                    :items="exercises"
                />
              </div>
              <div class="col-2 text-right">
                <button type="button" class="btn btn-success add-btn mt-4"  @click="exerciseForm=1">+</button>
              </div>
            </div>

            <TextElement name="repetitions" label="Ripetizioni" rules="required|integer" />
            <DateElement name="from_date" label="Da" rules="required"></DateElement>
            <DateElement name="to_date" label="Al" rules="required"></DateElement>
            <TextElement name="ranking" label="Giudizio" rules="nullable|integer|min:1|max:5" />

            <TextareaElement name="note" label="Note" />
            <TextElement name="free_field" label="Free Field" />
          </Vueform>

          <button type="button" id="close" class="btn btn-secondary" @click="horseTrainingForm=0">Chiudi</button>
          &nbsp;<button type="button" class="btn btn-primary" :class="{ loading: loading }"  @click="save">Salva</button>
    </div>

  </modal>

  <modal title="Add Training" v-model="trainingForm">

      <Vueform ref="formTraining$" >
          <TextElement name="training_name" label="Nome" rules="required" />
          <div class="row">
            <div class="col-10">
              <SelectElement
                name="training_type_id"
                :native="false"
                label="Training Type"
                rules="required"
                :items="training_types"
              />
            </div>
            <div class="col-2 text-right">
              <button type="button" class="btn btn-success add-btn mt-4"  @click="trainingTypeForm=1">+</button>
            </div>
          </div>
          

          <button type="button" id="close" class="btn btn-secondary btn-sm" @click="trainingForm=0">Chiudi</button>
          &nbsp;<button type="button" class="btn btn-primary btn-sm" :class="{ loading: loading }"  @click="saveTraining">Salva</button>
        </Vueform>

      </modal>

<modal title="Add Exercise" v-model="exerciseForm">
  <Vueform ref="formExercise$" >
    <TextElement name="exercise_name" label="Nome" rules="required" />
    <button type="button" id="close" class="btn btn-secondary btn-sm" @click="exerciseForm=0">Chiudi</button>
    &nbsp;<button type="button" class="btn btn-primary btn-sm" :class="{ loading: loading }"  @click="saveExercise">Salva</button>
  </Vueform>

</modal>

<modal title="Add Training Type" v-model="trainingTypeForm">

  <Vueform ref="formTrainingType$" >
    <TextElement name="training_type" label="Nome" rules="required" />
    <button type="button" id="close" class="btn btn-secondary btn-sm" @click="trainingTypeForm=0">Chiudi</button>
    &nbsp;<button type="button" class="btn btn-primary btn-sm" :class="{ loading: loading }"  @click="saveTrainingType">Salva</button>
  </Vueform>

</modal>
  
  </template>
  
  
  <script>
  
  import {horsesTrainingService} from "@/services/HorsesTrainingService";
  import CustomTable from "@/components/CustomTable";
  import Modal from "@/components/Modal";
  import { useToast } from "vue-toastification";
  import setNavPills from "@/assets/js/nav-pills.js";
import { useTableData } from "../../composables/useTableData";
  const toast = useToast();
  
  export default {
    name: "HorseTrainings",
    props: {
      id: {
        type: [String, Number],
        required: true,
        activeTab: 'inprogress',
      },
    },
    data() {
      return {
        loading: false,
        horse_training: {},
        trainings: [],
        exercises: [],
        training_types: [],
        horseTrainingForm: 0,
        exerciseForm: 0,
        trainingForm: 0,
        trainingTypeForm: 0,
      };
    },
    setup(){
    return useTableData(
        horsesTrainingService.getHorseTrainings.bind(horsesTrainingService),
        10
    );
  },
  created() {
    this.$store.dispatch('updateBreadcrumbs', [
      { title: 'Lista Cavalli', name: 'Horses' },
      { title: 'Cavallo', name: 'Horse', params: { id: this.id } }
    ]);
  },
    mounted(){
      this.fetchData({horse_id: this.id, status: this.activeTab});
      setNavPills();
      horsesTrainingService.getTrainings().then(trainings => this.trainings = trainings.map(t => ({value: t.id, label: t.name})));
      horsesTrainingService.getExercises().then(exercises => this.exercises = exercises.map(e => ({value: e.id, label: e.name})));
      horsesTrainingService.getTrainingTypes().then(training_types => this.training_types = training_types.map(t => ({value: t.id, label: t.name})));
    },
    computed: {
    },
    components: {
      CustomTable,
      Modal,
    },
    methods: {
      async saveExercise(){
        const form = this.$refs.formExercise$;
        form.validate();
        if (form.hasErrors) return;
        this.loading=true;
          try{
            const exercise = await horsesTrainingService.addExercise(this.$refs.formExercise$.data);
            toast(this.$t('operation_saved'));
            this.exercises.push({label: exercise.name, value: exercise.id});
            this.$refs.form$.elements$.exercise_id.update(exercise.id);
            this.exerciseForm = 0;
          }finally{
            this.loading=false;
          }
      },
      async saveTraining(){
        const form = this.$refs.formTraining$;
        form.validate();
        if (form.hasErrors) return;
        this.loading=true;
          try{
            const training = await horsesTrainingService.addTraining(this.$refs.formTraining$.data);
            toast(this.$t('operation_saved'));
            this.trainings.push({label: training.name, value: training.id});
            this.$refs.form$.elements$.training_id.update(training.id);
            this.trainingForm = 0;
          }finally{
            this.loading=false;
          }
      },
      async saveTrainingType(){
        const form = this.$refs.formTrainingType$;
        form.validate();
        if (form.hasErrors) return;
        this.loading=true;
          try{
            const training_type = await horsesTrainingService.addTrainingType(this.$refs.formTrainingType$.data);
            toast(this.$t('operation_saved'));
            this.training_types.push({label: training_type.name, value: training_type.id});
            this.$refs.formTraining$.elements$.training_type_id.update(training_type.id);
            this.trainingTypeForm = 0;
          }finally{
            this.loading=false;
          }
      },
      async runAction({action, row}){
        this.loading = true;
        if(action.key == 'edit'){
          horsesTrainingService.getHorseTrainingById(row.id).then((training) => {
            this.horse_training = training;
            this.loading=false;
            this.horseTrainingForm = 1;
          });
        }
      },
      clear(){
        this.horse_training = {};
        //this.$refs.form$.reset();
      },
      openHorseTrainingForm(){
        this.horseTrainingForm = 1;
        this.clear();
      },
      setActiveTab(tab) {
        this.activeTab = tab;
        this.handleSearchChange('');
        this.fetchData({horse_id: this.id, status: tab});
      },
      async save(){
        const form = this.$refs.form$;
        form.validate();
        if(this.horse_training.id) form.data.id = this.horse_training.id;
        form.data.horse_id = this.id;
        if (!form.hasErrors) {
          for (const key in form.data) {
            if (form.data[key] === 'null' || form.data[key] === null) {
                delete form.data[key];
            }
          }
          this.loading=true;
          try{
            await horsesTrainingService.saveHorseTraining(form.data);
            toast(this.$t('operation_saved'));
            this.horseTrainingForm = 0;
            this.fetchData({horse_id: this.id, status: this.activeTab});
          }finally{
            this.loading=false;
          }
        }
      },
    },
  };
  </script>
